let runesData = {
yin: 		["&#9790;", "Lunar"],
yang: 		["&#9737;", "Heliacal"],
Fehu: 		["&#5792;",	"Cattle/Wealth"],
Uruz: 		["&#5794;",	"Ox"],
Thurisaz: 	["&#5798;",	"Mallet/Giant"],
Ansuz: 		["&#5800;",	"Message"],
Raidho: 	["&#5809;",	"Journey"],
Kenaz: 		["&#5810;",	"Torch"],
Gebo:		["&#5815;",	"Torch"],
Wunjo:		["&#5817;",	"Gift"],
Hagalaz: 	["&#5818;",	"Joy"],
Nauthiz: 	["&#5822;",	"Hail"],
Isa:		["&#5825;",	"Needs"],
Jera:		["&#5827;",	"Harvest"],
Eihwaz: 	["&#5831;",	"Yew"],
Perthro: 	["&#5832;",	"Destiny"],
Algiz: 		["&#5833;",	"Elk"],
Sowilo: 	["&#5834;",	"Sun"],
Tiwaz: 		["&#5839;",	"Victory"],
Berkana: 	["&#5842;",	"Birch"],
Ehwaz: 		["&#5846;",	"Horse"],
Mannaz: 	["&#5847;",	"Man"],
Laguz: 		["&#5850;",	"Lake"],
Ingwaz: 	["&#5853;",	"Fertility"],
Othala: 	["&#5855;",	"Heritage"],
Dagaz: 		["&#5854;",	"Dawn"]};
export default runesData;